export default __webpack_public_path__ + "static/event-graphia-e9a095104913a8bd005fe08f2f32df9b.jpg";